module.exports = __webpack_public_path__ + "static/media/plan-with-inserts-img.d7eda681.svg";